

/**
 * @ngdoc function
 * @name app.controller:ModalImportExcelCtrl
 * @description
 * # ModalImportExcelCtrl
 * Controller of the app
 */
angular.module('app')
	.controller('ModalImportExcelCtrl', /* @ngInject */ function ($scope, $translate, $uibModalInstance, name) {
		$scope.filename = name;

		$scope.submit = function (filename) {
			$uibModalInstance.close($scope.filename);
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
	});
